import { useState } from 'react'
import { PaperPlaneRightIcon } from '@phosphor-icons/react'
import { ScoopButton, ScoopRow, ScoopTextField } from '../../../ui'
import styles from './HelpBotInput.module.scss'

export const HelpBotInput = ({ onSend, disabled }) => {
    const [value, setValue] = useState('')

    const handleSubmit = () => {
        const trimmed = value.trim()
        if (trimmed && !disabled) {
            onSend(trimmed)
            setValue('')
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault()
            handleSubmit()
        }
    }

    return (
        <ScoopRow align="flex-end" gap={8} className={styles.inputContainer}>
            <ScoopTextField
                autoResize
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="What can I do with Scoop?"
                disabled={disabled}
                className={styles.textarea}
                disableMargin
            />
            <ScoopButton
                variant={value.trim() ? 'primary' : 'default'}
                size="xs"
                onClick={handleSubmit}
                disabled={disabled || !value.trim()}
                className={styles.sendButton}
                aria-label="Send message"
            >
                <PaperPlaneRightIcon size={18} weight="fill" />
            </ScoopButton>
        </ScoopRow>
    )
}
